import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useAliveController } from 'react-activation';
import {
  setAboutVisible,
  setCheckUpdateVisible,
  setDownloadPathVisible,
  setOperationMenuVisible,
  setPhoneVisible,
  setReleaseNotesVisible,
  setUserFeedbackVisible,
  setShareVisible,
  setShareLink,
  setMessageVisible,
} from '../../actions/layout';
import { setFeedbackTab } from '../../actions/userFeedback';
import { logging, logPostInfo } from '../../actions/log';
import {
  CONTEXT,
  // DEVELOPER_URL,
  // USER_FEEDBACK_URL,
  APP_VERSION,
  APP_VERSION_D,
} from '../../config';
import { cacheKeys } from '../../constants/storageKeys';
import styles from './OperationMenu.module.less';
import { WEB_STORE } from '../../config';
import { deleteMessageHot } from '../../actions/message';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
// 独立包-检查更新版本信息
const selectNewVersionInfo = createSelector(
  state => state.layout,
  Layout => Layout.newVersionInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectMessage = createSelector(
  state => state.message,
  message => ({
    hotMessage: message.hot,
  }),
);

export default memo(() => {
  const history = useHistory();
  const dispatch = useDispatch();
  const newVersionInfo = useSelector(selectNewVersionInfo);
  const logInfoData = useSelector(selectLogInfo);
  const [startInfo, setStartInfo] = useState({});
  const releaseNotesVersion = localStorage.getItem(cacheKeys.RELEASE_NOTES_VERSION);
  const userInfo = useSelector(selectUserInfo);
  const { hotMessage } = useSelector(selectMessage);
  const [loginStatus, setLoginStatus] = useState(false);
  const { dropScope } = useAliveController();

  useEffect(() => {
    const login_status = window.CallNativeMethod('get_login_status');
    if (!(login_status !== '1' || !userInfo.st)) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);
  /**
   * 初始化信息
   */
  useEffect(() => {
    // 获取startInfo
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
    const startInfos = JSON.parse(startInfoStr || '{}');
    setStartInfo(startInfos);
  }, [newVersionInfo]);

  const closeOtherDialog = useCallback(
    dialog => {
      dispatch(setOperationMenuVisible(false));
      // dispatch(setDownloadPathVisible(dialog === 'Setting'));
      dispatch(setAboutVisible(dialog === 'About'));
      dispatch(setPhoneVisible(dialog === 'Phone'));
      dispatch(setCheckUpdateVisible(dialog === 'CheckUpdate'));
      dispatch(setReleaseNotesVisible(dialog === 'ReleaseNotes'));
      dispatch(setUserFeedbackVisible(dialog === 'userFeedback'));
      dispatch(setShareVisible(dialog === 'Share'));
      dispatch(setMessageVisible(dialog === 'Message'));
    },
    [dispatch],
  );

  const handleForum = useCallback(ev => {
    // 点击 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Forum',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `HomePage`,
        source_pp: logInfoData.source_p,
      }),
    );
    ev.stopPropagation();

    closeOtherDialog('Forum');
    dropScope('forumlist');
    setTimeout(() => {
      history.push(`${CONTEXT}/forumlist`);
    }, 50);
  }, []);

  const handleSetting = useCallback(
    ev => {
      // 点击 下载管理 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Setting',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('Setting');
      // dispatch(setDownloadPathVisible(true));
      history.push(`${CONTEXT}/setting`);
    },
    [dispatch, logInfoData],
  );

  const handleFeedback = ev => {
    // 点击 下载管理 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Feedback',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    ev.stopPropagation();
    // 我要反馈的屏蔽
    closeOtherDialog('userFeedback');

    if (loginStatus && hotMessage[3] === '1') {
      dispatch(deleteMessageHot({ code: 3 }));
      dispatch(setFeedbackTab('question'));
    }
    // window.open(USER_FEEDBACK_URL);
  };

  const handleAbout = useCallback(
    ev => {
      // 点击 关于 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'About',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('About');
    },
    [dispatch, logInfoData],
  );
  const handleCheckUpdate = useCallback(
    ev => {
      // 点击 check更新 打桩
      dispatch(
        logging({
          category: 'R',
          action: 'About_Update',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            mes: newVersionInfo && newVersionInfo.error && 'INDE_GET_LATEST_UPDATE failed',
            update: newVersionInfo && newVersionInfo.error ? 0 : 1,
            updateversion: newVersionInfo && newVersionInfo.versionName,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('CheckUpdate');
    },
    [dispatch, logInfoData],
  );

  // const handleDeveloper = useCallback(
  //   ev => {
  //     // 点击 商业合作 打桩
  //     dispatch(
  //       logging({
  //         category: 'C',
  //         action: 'business',
  //         label: '',
  //         param2: {
  //           source: 'HomePage',
  //           source_p: logInfoData.source_p,
  //           source_pp: logInfoData.source_pp,
  //         },
  //       }),
  //     );
  //     ev.stopPropagation();
  //     closeOtherDialog('Trade');
  //     window.open(DEVELOPER_URL);
  //   },
  //   [dispatch, logInfoData],
  // );

  // const handlePhone = useCallback(
  //   ev => {
  //     // 点击 关于 打桩
  //     dispatch(
  //       logging({
  //         category: 'C',
  //         action: 'Phone',
  //         label: '',
  //         param2: {
  //           source: 'HomePage',
  //           source_p: logInfoData.source_p,
  //           source_pp: logInfoData.source_pp,
  //         },
  //       }),
  //     );
  //     ev.stopPropagation();
  //     closeOtherDialog('Phone');
  //   },
  //   [dispatch, logInfoData],
  // );

  const handleReleaseNotes = useCallback(
    ev => {
      // 点击 关于 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'ReleaseNotes',
          label: '',
          param2: {
            source: logInfoData.source || 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      window.localStorage.setItem(
        cacheKeys.RELEASE_NOTES_VERSION,
        startInfo.isDStore ? APP_VERSION_D : APP_VERSION,
      );
      closeOtherDialog('ReleaseNotes');
    },
    [dispatch, logInfoData, startInfo],
  );

  const handleShare = ev => {
    // 点击 分享 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Store_Share',
        label: '',
        param2: {
          source: logInfoData.source || 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      setShareLink({
        address: `${WEB_STORE}/about`,
        info: { from: 'HomePage' },
        logInfo: { source: 'HomePage' },
        soft: null,
      }),
    );
    ev.stopPropagation();
    closeOtherDialog('Share');
  };

  const handleMessage = ev => {
    ev.stopPropagation();
    closeOtherDialog('Message');
    dispatch(
      logging({
        category: 'C',
        action: 'Message',
        label: '',
        param2: {
          source: logInfoData.source || 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  return (
    <div className={styles.operation_menu}>
      {/* <a className="line" onClick={handleForum}>
        <i className="iconfont icon-toolbar_forum" />
        <span className="line-text">酷软圈</span>
      </a> */}
      <a className="line" onClick={handleSetting}>
        <i className="iconfont icon-toolbar_setting" />
        <span className="line-text">设置中心</span>
      </a>
      <a className="line" onClick={handleFeedback}>
        <i className="iconfont icon-toolbar_feedback" />
        <div className={styles.hotBox}>
          {loginStatus && hotMessage[3] === '1' && <div className={styles.hot} />}
          <span className="line-text">我要反馈</span>
        </div>
      </a>
      {startInfo && startInfo.isDStore && (
        <a className="line" onClick={handleCheckUpdate}>
          <i className="iconfont icon-toolbar_update" />
          <div className={styles.hotBox}>
            {newVersionInfo && newVersionInfo.versionName && <div className={styles.hot} />}
            <span className="line-text">检查更新</span>
          </div>
        </a>
      )}
      <a className="line" onClick={handleAbout}>
        <i className="iconfont icon-toolbar_about" />
        <span className="line-text">关于我们</span>
      </a>
      {/* <a className="line" onClick={handleDeveloper}>
        <i className="iconfont icon-toolbar_trade" />
        <span className="line-text">商务合作</span>
      </a> */}
      <a className="line" onClick={handleReleaseNotes}>
        <i className="iconfont icon-new_features" />
        <div className={styles.hotBox}>
          {releaseNotesVersion !== (startInfo.isDStore ? APP_VERSION_D : APP_VERSION) && (
            <div className={styles.hot} />
          )}
          <span className="line-text">新版特性</span>
        </div>
      </a>
      <a className="line" onClick={handleShare}>
        <i className="iconfont icon-pc_share" />
        <span className="line-text">推荐给好友</span>
      </a>
    </div>
  );
});
